import React from 'react';
import ImagemTwitter from 'assets/img/iconTwit.png';
import ImagemFacebook from 'assets/img/iconFace.png';
import ImagemInstagram from 'assets/img/iconInsta.png';
import ImagemSefaz from 'assets/img/logoSefazVerticalVazadaBranca.svg';
import * as S from './styles';
import { altImageSefaz } from 'utils/acessibilidade';

export default function Footer() {
  const urlFacebook = 'https://www.facebook.com/FazendaMunicipalSalvador/';
  const urlTwitter = 'https://twitter.com/AGECOMSALVADOR';
  const urlInstagram = 'https://www.instagram.com/sefazsalvador/';

  return (
    <S.Container>
      <div>
        <S.RedesSociais>
          <S.Seguidores>Siga-nos nas redes sociais</S.Seguidores>
          <a href={urlFacebook}>
            <S.Icon src={ImagemFacebook} alt="Facebook" />
          </a>
          <a href={urlTwitter}>
            <S.Icon src={ImagemTwitter} alt="Twitter" />
          </a>
          <a href={urlInstagram}>
            <S.Icon src={ImagemInstagram} alt="Instagram" />
          </a>
        </S.RedesSociais>

        <S.Endereco>
          <div>
            Posto Central Rua das Vassouras, nº 1 - Centro Histórico <br />
            Atendimento: segunda a sexta-feira - 8h às 16h
            <S.Copy>&copy; 2017 - Todos os direitos reservados </S.Copy>
          </div>
          <S.Logo src={ImagemSefaz} alt={altImageSefaz} />
        </S.Endereco>
      </div>
    </S.Container>
  );
}
